module.exports = __webpack_public_path__ + "static/media/notes-of-love-two.d6fb31e2.png";